import {EventEmitter, Injectable} from '@angular/core';
import {GfxStoreService} from 'src/app/services/gfx.store.service';
import {IUser} from 'src/app/models/IUser';
import {IAuthObject} from 'src/app/models/IAuthObject';
import {Router} from '@angular/router';
import {RefsService} from 'src/app/services/refs.service';
import {GfxHttpSrv} from 'src/app/services/GfxHttpSrv';
import {IGfxOpResObj} from '../models/IGfxOpResObj';
import {jwtDecode} from 'jwt-decode';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {TokenRefreshService} from './token-refresh.service';
import {catchError, switchMap, tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private currentUserSubject = new BehaviorSubject<any>(null);
    public currentUser$ = this.currentUserSubject.asObservable();

    constructor(
        private http: GfxHttpSrv,
        private store: GfxStoreService,
        private router: Router,
        private refs: RefsService,
        private tokenRefreshService: TokenRefreshService
    ) {
    }

    authProcessed: EventEmitter<IGfxOpResObj> = new EventEmitter<IGfxOpResObj>();
    userLoggedOut = new EventEmitter<void>();
    matricule ;
    login(authObj: IAuthObject) {
        const urlLogin = 'auth/login';
        this.doLogin(urlLogin, authObj);
    }


    getMenAndDefaultUI() {

        // this.getDefaultTdb().subscribe((resp) => {
        //     if (resp && resp.data != 'null') {
        //         this.router.navigateByUrl(resp.data);
        //     } else {
        //         this.router.navigateByUrl('apropos');
        //     }
        // });

        this.getDefaultTdb().subscribe((resp) => {
            const matricule = this.matricule;

            if (resp && resp.data !== 'null') {
                this.router.navigate([resp.data], { queryParams: { matricule } });
            } else {
                this.router.navigate(['apropos']);
            }
        });


    }

    getDefaultTdb() {
        return this.http.get('portal/roles/defaultTdb');
    }

    postLogout() {
        return this.http.get(
            'auth/logout'
        );
    }

    logout() {
        this.postLogout().subscribe();
        this.store.changeUser(null);        // ensure BehaviorSubject emits null
        this.store.removeCurChoixProf();
        this.router.navigate(['auth/login']);
        this.userLoggedOut.emit();
        this.currentUserSubject.next(null);
        this.currentUser$ = null;
    }

    private doLogin(url: string, authObj: IAuthObject, modeRoot?) {
        this.http
            .post(url, {usr: authObj.utilisateur, pwd: authObj.motDePasse})
            .subscribe(
                (res: IUser) => {
                    this.store.onGoingPostOrPut = false;
                    if (!res.access_token) {
                        let msg = res[0];
                        if (typeof res == 'string') {
                            msg = res;
                        }
                        this.authProcessed.emit({
                            OpSuccess: 0,
                            Msg: msg,
                        });
                    } else {

                        res.access_token = 'Bearer ' + res.access_token;
                        if (modeRoot) {
                            res.isImpersonate = false;
                        }
                        this.store.changeUser(res);
                        this.store.currentUser.subscribe((data) => {
                            this.matricule=data.login;
                            this.refs.getRoleById(data.id_role).subscribe(role => {
                                this.store.cur_profil_choix = {
                                    role: role
                                };
                                this.store.profilChangeEvent.emit('');
                                if (data.firstAccess) {
                                    this.getMenAndDefaultUI(); /* pour l'instant */
                                } else {
                                    this.getMenAndDefaultUI();
                                }
                            });
                            this.currentUserSubject.next(res);
                        });
                    }
                },
                (error) => {
                    this.store.onGoingPostOrPut = false;
                    let msg = error.error.msg;

                    if (typeof error == 'string') {
                        msg = error;
                    }

                    this.authProcessed.emit({
                        OpSuccess: 0,
                        Msg: msg,
                    });
                }
            );
    }


    isTokenExpired(token: any) {
        if (!token) {
            return true;
        }
        try {
            const decodedToken: any = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);
            return decodedToken.exp < currentTime;
        } catch (error) {
            return true;
        }
    }

    postRefresh(): Observable<any> {
        return this.http.post('auth/refreshtoken', {}).pipe(
            catchError(error => {
                this.tokenRefreshService.failRefresh(error);
                return throwError(error);
            })
        );
    }

    forgotPassword(email: string) {
        return this.http.post('portal/auth/forgot-password', {email: email});
    }

    getCurrentUser() {
        return this.http.get('portal/roles/getCurrentUserInfo');
    }


    initialize() {
        if (this.store.curUser) {
            this.tokenRefreshService.startRefresh();

            this.postRefresh().pipe(
                switchMap((currentUser: any) => {
                    currentUser.access_token = `${currentUser.token_type} ${currentUser.access_token}`;
                    this.store.changeUser(currentUser);
                    this.tokenRefreshService.completeRefresh(this.store.curUser.access_token);
                    return this.refs.getRoleById(this.store.curUser.id_role).pipe(
                        tap(role => {
                            this.store.cur_profil_choix = {role};
                            this.store.profilChangeEvent.emit('');
                            const currentUrl = this.router.url;
                            if (currentUser.firstaccess) {
                                this.router.navigate(['ChangePassword']);
                            } else if (currentUrl === '/' || currentUrl === '/login') {
                                this.getMenAndDefaultUI();
                            } else {
                                this.router.navigateByUrl(currentUrl);
                            }
                        })
                    );
                }),
                catchError((err) => {
                    this.store.changeUser(null);
                    this.tokenRefreshService.failRefresh(err);
                    return throwError(err);
                })
            ).subscribe();
        }


    }
}
